/**
 * Client-side checks for RFQ → supplier flows. Mirrors backend
 * `OrderService.assignRfqToSupplier` (custom products only).
 */

/** Same text as backend ValidationException so UX matches API errors. */
export const SUPPLIER_QUOTE_REQUIRES_CUSTOM_MESSAGE =
  'Supplier quote requires custom products only. Remove inventory items and add a new custom product before sending to suppliers.';

/**
 * @param {Array<{ product?: { is_custom?: boolean }, is_custom?: boolean }>|undefined|null} orderDetails
 * @returns {boolean} true if any line is not strictly custom (inventory or missing flag)
 */
export function orderDetailsContainNonCustomProduct(orderDetails) {
  if (!Array.isArray(orderDetails) || orderDetails.length === 0) {
    return false;
  }
  return orderDetails.some((od) => {
    if (!od) return true;
    const isCustom = od.product?.is_custom ?? od.is_custom;
    return isCustom !== true;
  });
}
